var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHorGreen1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 330.3 8.7",
    style: {
      enableBackground: "new 0 0 330.3 8.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#528918;}\n\t.st1{fill:#9CB6B7;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000002351685639177952800000010945180776708945823_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    className: "st0",
    width: 329.5,
    height: 8.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M330.2,8.7h-14.4V0h14.4V8.7z M301.5,8.7h-14.4V0h14.4V8.7z M272.8,8.7h-14.4V0h14.4V8.7z M244.1,8.7h-14.4V0 h14.4V8.7z M215.4,8.7H201V0h14.4V8.7z M186.6,8.7h-14.4V0h14.4V8.7z M157.9,8.7h-14.4V0h14.4V8.7z M129.2,8.7h-14.4V0h14.4V8.7z  M100.5,8.7H86.1V0h14.4V8.7z M71.8,8.7H57.4V0h14.4V8.7z M43.1,8.7H28.7V0h14.4V8.7z M14.4,8.7H0V0h14.4V8.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorGreen1);
export default __webpack_public_path__ + "static/media/horGreen1.2bdde89d48190a7a871719562b654f93.svg";
export { ForwardRef as ReactComponent };